import { STRINGS_NLS } from '../nls/strings_nls'
import type { AppTheme, CosmeticRarity } from '../types/schema'

export type ThemeCatalogEntry = {
  key: AppTheme
  label: string
  description: string
  rarity?: CosmeticRarity
  cosmeticId?: string
  swatch: {
    surface: string
    accent: string
    highlight: string
  }
}

export const THEME_CATALOG: ThemeCatalogEntry[] = [
  {
    key: 'MOSAIC_LIGHT',
    label: STRINGS_NLS.NLSThemeMosaicLightLabel.text,
    description: STRINGS_NLS.NLSThemeMosaicLightDescription.text,
    swatch: { surface: '#ffffff', accent: '#6553f5', highlight: '#f3f4f8' }, // mosaic-keep: data (theme catalog preview swatch)
  },
  {
    key: 'MOSAIC_DARK',
    label: STRINGS_NLS.NLSThemeMosaicDarkLabel.text,
    description: STRINGS_NLS.NLSThemeMosaicDarkDescription.text,
    swatch: { surface: '#171a24', accent: '#9a8cff', highlight: '#0e1017' }, // mosaic-keep: data (theme catalog preview swatch)
  },
  {
    key: 'LIGHT',
    label: 'Light',
    description: 'Bright daylight palette.',
    swatch: { surface: '#f8fafc', accent: '#6366f1', highlight: '#e2e8f0' }, // mosaic-keep: data (theme catalog preview swatch)
  },
  {
    key: 'DARK',
    label: 'Dark',
    description: 'The classic Timelining dark.',
    swatch: { surface: '#0f172a', accent: '#818cf8', highlight: '#334155' }, // mosaic-keep: data (theme catalog preview swatch)
  },
  {
    key: 'OLED_BLACK',
    label: 'OLED Black',
    description: 'True black for OLED panels.',
    swatch: { surface: '#000000', accent: '#a78bfa', highlight: '#1f1f1f' }, // mosaic-keep: data (theme catalog preview swatch)
  },
  {
    key: 'MIDNIGHT',
    label: 'Midnight',
    description: 'Deep cobalt void with cool mist.',
    rarity: 'COMMON',
    cosmeticId: 'theme_midnight',
    swatch: { surface: '#0b1a3d', accent: '#60a5fa', highlight: '#1e3a8a' }, // mosaic-keep: data (theme catalog preview swatch)
  },
  {
    key: 'AURORA',
    label: 'Aurora',
    description: 'Luminous teal/violet veil.',
    rarity: 'RARE',
    cosmeticId: 'theme_aurora',
    swatch: { surface: '#0f2937', accent: '#2dd4bf', highlight: '#a855f7' }, // mosaic-keep: data (theme catalog preview swatch)
  },
  {
    key: 'EMBER',
    label: 'Ember',
    description: 'Warm coal with amber flicker.',
    rarity: 'EPIC',
    cosmeticId: 'theme_ember',
    swatch: { surface: '#1c0f0a', accent: '#f97316', highlight: '#fbbf24' }, // mosaic-keep: data (theme catalog preview swatch)
  },
  {
    key: 'CELESTIAL',
    label: 'Celestial',
    description: 'Shifting starfield, iridescent gold.',
    rarity: 'LEGENDARY',
    cosmeticId: 'theme_celestial',
    swatch: { surface: '#0a0a23', accent: '#fbbf24', highlight: '#a78bfa' }, // mosaic-keep: data (theme catalog preview swatch)
  },
  {
    key: 'PEARL',
    label: 'Pearl',
    description: 'Cool porcelain white with an iris-violet accent and a faint lilac haze.',
    rarity: 'COMMON',
    cosmeticId: 'theme_pearl',
    swatch: { surface: '#f6f5fb', accent: '#6d5bd0', highlight: '#4632a8' }, // mosaic-keep: data (theme catalog preview swatch)
  },
  {
    key: 'LINEN',
    label: 'Linen & Gold',
    description: 'Warm ivory paper with champagne-gold accents, like a well-made notebook.',
    rarity: 'COMMON',
    cosmeticId: 'theme_linen',
    swatch: { surface: '#f7f2e8', accent: '#b07d1f', highlight: '#7a520a' }, // mosaic-keep: data (theme catalog preview swatch)
  },
  {
    key: 'GLACIER',
    label: 'Glacier',
    description: 'Icy blue-white with a deep teal accent, and mint and sky light at the corners.',
    rarity: 'RARE',
    cosmeticId: 'theme_glacier',
    swatch: { surface: '#eef5f7', accent: '#0e8f86', highlight: '#075e58' }, // mosaic-keep: data (theme catalog preview swatch)
  },
  {
    key: 'BLUSH',
    label: 'Blush',
    description: 'Rose-quartz light with a raspberry accent, and peach and pink glows.',
    rarity: 'EPIC',
    cosmeticId: 'theme_blush',
    swatch: { surface: '#faf1f2', accent: '#c2416b', highlight: '#8a2449' }, // mosaic-keep: data (theme catalog preview swatch)
  },
  {
    key: 'SAGE',
    label: 'Sage',
    description: 'Soft green-grey paper with a forest-moss accent. Quiet and restful for long sessions.',
    rarity: 'LEGENDARY',
    cosmeticId: 'theme_sage',
    swatch: { surface: '#f1f4ec', accent: '#4f7a32', highlight: '#2f4f1a' }, // mosaic-keep: data (theme catalog preview swatch)
  },
]
